import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Service } from 'src/app/shared/services/service';
import { isPlatformBrowser } from '@angular/common';
import { RESPONSE } from '@nguniversal/express-engine/tokens';

@Injectable({
  providedIn: 'root',
})
export class UtilsService extends Service {

  constructor(
    http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private serverResponse: any,
  ) {
    super(http);
  }

  pullTranslations(): Observable<void> {
    return this.http.post<void>(this.url + '/snack/v1/translations/pull', {});
  }

  clearApiCache(): Observable<void> {
    return this.http.post<void>(this.url + '/snack/v1/clear-cache', {});
  }

  disableResponseCache() {
    if (!this.isBrowser && this.serverResponse) {
      this.serverResponse.locals.disableResponseCache = true;
    }
  }

  setResponseCacheDuration(seconds: number) {
    if (!this.isBrowser && this.serverResponse) {
      this.serverResponse.locals.responseCacheDuration = seconds;
    }
  }

  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

}


export enum CacheTime {
  Hour = 3600,
  ThreeHours = Hour * 3,
  SixHours = Hour * 6,
  Day = Hour * 24,
  ThreeDays = Day * 3,
  Week = Day * 7,
  Month = Day * 30
}
